module.exports = __webpack_public_path__ + "static/playback_pathways-c1438e8be54782a28c80c9d70dd469f0.png";